<template>
  <v-container v-if="errorMsg" class="qes-alert mt-4">
    <v-row>
      <img class="alert-icon mr-4 ml-1" :src="alert" />
      <v-col
        cols="10"
        sm="11"
        class="pl-1 d-flex error-alert"
        v-if="errorMsg == 'failedsignature'"
      >
        <p class="mb-0">
          {{ $t('errors.' + errorMsg)[0] }}
          <a
            :href="'mailto:info@wallid.io'"
            @click="sendEvent()"
            target="_blank"
          >
            {{ $t('errors.' + errorMsg)[1] }}
          </a>
        </p>
      </v-col>
      <v-col
        v-else-if="$te('errors.' + errorMsg)"
        cols="10"
        sm="11"
        class="pl-1 error-alert"
      >
        <p class=" mb-0">{{ $t('errors.' + errorMsg) }}</p>
      </v-col>
      <v-col v-else cols="10" sm="11" class="pl-1 error-alert">
        <p class=" mb-0">{{ errorMsg }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorBanner',
  props: {
    errorMsg: {
      type: String,
    },
  },
  methods: {
    sendEvent() {
      this.$gtag.event('Click contact us', {
        event_category: 'Error',
        event_label: 'Error Banner',
      });
    },
  },
  data() {
    return {
      alert: require('@/assets/alert-qes.svg'),
    };
  },
};
</script>

<style scoped lang="scss">
.qes-alert {
  padding: 12px 24px;
  .row {
    padding: 12px;
    min-height: 76px;
    background-color: #fce7e7;
    opacity: 1;
    border: solid 1px #e95e5e;
    border-radius: 4px;
    display: flex;
    padding-right: 24px;
  }

  .error-alert {
    p,
    a {
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      color: #3e444d;
    }
    & a {
      color: #009fb1;
      text-decoration: none;
    }
  }
  .alert-icon {
    width: 20px;
    margin: 0px;
  }
}
</style>
